import styles from './Logo.module.css';

/**
 * Logo — CRYPTMET brand logo image
 */
const Logo = ({ size = 'default', className = '' }) => (
  <img
    src="/assets/images/logo/Cryptmet.png"
    alt="CRYPTMET"
    className={`${styles.logo} ${styles[size] || ''} ${className}`}
    draggable={false}
  />
);

export default Logo;
